import React, { Fragment } from 'react'
import { useIntl } from 'react-intl';

const CheckboxFilterSearchInput = ({ searchValue, onSearchChange, options }) => {
  const intl = useIntl();

  return (
    <Fragment>
      <div className="products-search-input">
        <div className="form-group mb-4">
          <input
            type="text"
            placeholder={intl.formatMessage({ id: "FlameRetardancySearchInput.placeholder" })}
            className="form-control"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <i className="fa fa-search" />
        </div>
      </div>
      {options.length === 0 && (
        <p>{intl.formatMessage({ id: "FlameRetardancySearchInput.noResults" })}</p>
      )}
    </Fragment>
  );
}

CheckboxFilterSearchInput.defaultProps = {
  searchValue: "",
  onSearchChange: () => {},
  options: []
}

export default CheckboxFilterSearchInput
